<template>
  <div id="contenedor-main-contrato-escalatorias">
    <!-- ToolBar -->
    <tool-bar
      v-if="!soloLectura"
      v-on:nuevaEscalatoria="nuevaEscalatoria">
    </tool-bar>
    <!-- Loader -->
    <v-skeleton-loader
      v-if="$apollo.loading"
      type="table-heading, table-thead, table-tbody">
    </v-skeleton-loader>
    <listado
      v-if="!$apollo.loading"
      :solo-lectura="soloLectura"
      :listado="getContratoEscalatorias">
    </listado>
    <v-dialog
      v-model="mostrarRegistrarEscalatoria"
      width="600"
      persistent>
      <registrar-escalatorias
        v-if="mostrarRegistrarEscalatoria"
        :id-contrato="$route.params.idContrato"
        v-on:cerrar="cerrarVentana">
      </registrar-escalatorias>
    </v-dialog>
    <v-dialog
      v-model="mostrarEditarEscalatoria"
      width="600"
      persistent>
      <editar-escalatoria
        v-if="estaEscalatoria"
        :escalatoria-editar="estaEscalatoria"
        v-on:cerrar="cerrarVentana">
      </editar-escalatoria>
    </v-dialog>
    <v-dialog
      v-if="estaEscalatoria"
      v-model="mostrarEliminarEscalatoria"
      :width="!$vuetify.breakpoint.mobile ? '450' : '90%'">
        <eliminar-escalatoria
          :contratoEscalatoriaEliminar="estaEscalatoria"
          v-on:cerrar="cerrarVentana">
        </eliminar-escalatoria>
    </v-dialog>
  </div>
</template>

<script>
import CONTRATO_ESCALATORIAS from '@/graphql/querys/administracion/contratos/escalatorias/contratoEscalatorias.gql';
import RegistrarEscalatorias from '@/components/administracion/contratos/contrato/escalatorias/Nueva.vue';
import EditarEscalatoria from '@/components/administracion/contratos/contrato/escalatorias/Editar.vue';
import EliminarEscalatoria from '@/components/administracion/contratos/contrato/escalatorias/Eliminar.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'MainContratoEscalatorias',
  components: {
    RegistrarEscalatorias,
    EditarEscalatoria,
    EliminarEscalatoria,
    ToolBar,
    Listado,
  },
  props: {
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      mostrarRegistrarEscalatoria: false,
      mostrarEditarEscalatoria: false,
      mostrarEliminarEscalatoria: false,
      estaEscalatoria: null,
    };
  },
  apollo: {
    contratoEscalatorias: {
      query: CONTRATO_ESCALATORIAS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  mounted() {
    eventBus.$on('editar-contrato-escalatoria', (escalatoria) => {
      this.estaEscalatoria = escalatoria;
      this.mostrarEditarEscalatoria = true;
    });
    eventBus.$on('eliminar-contrato-escalatoria', (escalatoria) => {
      this.estaEscalatoria = escalatoria;
      this.mostrarEliminarEscalatoria = true;
    });
  },
  methods: {
    nuevaEscalatoria() {
      this.mostrarRegistrarEscalatoria = true;
    },
    cerrarVentana() {
      this.estaEscalatoria = null;
      this.mostrarRegistrarEscalatoria = false;
      this.mostrarEditarEscalatoria = false;
      this.mostrarEliminarEscalatoria = false;
    },
  },
  computed: {
    getContratoEscalatorias() {
      if (!this.contratoEscalatorias) return [];
      return this.contratoEscalatorias
        .slice()
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    },
  },
};
</script>

<style lang="scss">

</style>
